// All Forgot password form validation options should be used from this place
const forgotPasswordOptions = {
  email: {
    required: 'email_is_required',
    pattern: {
      value: RegExp('^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+[.]+[.a-zA-Z]{2,8}$'),
      message: 'invalid_email_address'
    },
    maxLength: {
      value: 100,
      message: 'email_max_character_length'
    }
  },
  captcha: {
    required: 'please_verify_whether_you_are_a_human'
  }
};
const defaultValues = {
  email: '',
  captcha: ''
};

export { forgotPasswordOptions, defaultValues };
